export const DEFAULT_BANNER_TOP_PX = 50;
export const ESTIMATE_NAV_SCROLLED_TOP_PX = 44;
export const ESTIMATE_NAV_TOP_EXTRA_OFFSET_PX = 40;
export const ESTIMATE_NAV_SCROLL_TRIGGER_PX = 40;
